import fetch from '@/utils/fetch'

export const List = '/order/acs/list'

export function handleExport (query) {
  return fetch({
    url: '/order/acs/list',
    method: 'get',
    params: query
  })
}
